import { AgentThreadsTable } from "./AgentThreadsTable";

export function ThreadsTab() {
  return <AgentThreadsTable />;
}
